export default function GET_INSTAGRAM(area = 'body') {
  const $containers = $('[data-plugin="getInstagram"]', area);

  if ($containers.length === 0) return false;

  const defarr = [];
  $containers.each((i, obj) => {
    const d = new $.Deferred();
    defarr.push(d.promise());

    const defaultOpt = {
      amount: 20, // 表示件数
      prefix: 'p-instagram',
      dispSize: 185,
      targetUser: 'iaso_hinokinokouso_spa',
      accessToken: 'EAAHltb9yPYQBACrxYgjQIct1GoWnEmPT8Xd2c4EZAI4ZA6ZCj9vxAUeH6Y6ZCX4dtxhUcovJZBpK7MaSogIHBjF43idMLcyuE2HbAZBuQQvW6Lnze9ATRTf9OOt8VhsKW2wuWxgSor4IyiozPpQ5bW5tkZBWgFn6HjT3IBvivrJRadbdynrviC9IqGNnCXWeSgZD',
      businessId: '17841402109108067'
    };

    // data属性からオーバーライドできるようにする
    const param = $.extend(true, defaultOpt, obj.dataset);

    fetch(
      `https://graph.facebook.com/v19.0/${param.businessId}?fields=business_discovery.username(${param.targetUser}){id,followers_count,media_count,media.limit(${param.amount}){caption,media_url,thumbnail_url,permalink,like_count,comments_count,media_type}}&access_token=${param.accessToken}`
    )
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(resObjects => {
      let mediaObj = (resObjects.business_discovery) ? resObjects.business_discovery.media.data : [];

      if (!mediaObj || mediaObj.length === 0) {
        $(obj).html(`<p style="text-align:center;width:100%;">投稿が見つかりませんでした。</p>`);
        d.resolve(resObjects);
        return;
      }

      $(obj).empty();

      $.each(mediaObj, (i, v) => {
        let imgurl;
        switch (v.media_type) {
          case 'IMAGE':
          case 'CAROUSEL_ALBUM':
            imgurl = v.media_url;
            break;
          case 'VIDEO':
            imgurl = v.thumbnail_url;
            break;
        }

        if (imgurl === undefined || imgurl === null) {
          return;
        }

        $(`
          <figure class="${param.prefix}__item">
            <a href="${v.permalink}" target="_blank" style="background-image:url('${imgurl}')" class="is-${v.media_type.toLowerCase()}">
              <img src="${imgurl}" alt="${v.caption || ''}" width="${param.dispSize}" />
            </a>
          </figure>
        `).appendTo(obj);
      });
      d.resolve(resObjects);
    })
    .catch(error => {
      console.error("Failed to fetch Instagram data:", error);
      $(obj).html(`<p style="text-align:center;width:100%;">Instagramフィードの読み込み中にエラーが発生しました。</p>`);
      d.reject(error);
    });
  });

  return $.when.apply($, defarr);
}